import createAuthAxios from 'common/lib/createAuthAxios';

export type FetchUserUiStateResponse = Readonly<{
  data: {
    id: string;
    attributes: {
      conversationAssistantOpenedCount: number;
    };
  };
}>;

const fetchUserUiState = async () => {
  const authAxios = createAuthAxios();

  const url = `/api/admin/ui_states`;
  const method = 'GET';
  const params = {};
  const { data } = await authAxios.request<FetchUserUiStateResponse>({ url, method, params });

  return data;
};

export default fetchUserUiState;
